import { Flex, Spin } from "antd"

const Loading: React.FC = () => {
    return (<Flex align="center" justify="center" style={{ height: '100vh' }}>
        <Spin size="large" ></Spin>
    </Flex>)
}

export default Loading;